function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  // document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    // Summary clicks = normal submenu behavior (exclude details-modal summaries)
    this.querySelectorAll('summary').forEach((summary) => {
      if (summary.closest('details-modal')) return;
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    });

    // Only real close buttons close the drawer
    this.querySelectorAll('button[aria-label="Close menu"], .menu-drawer__close-button, button.close-menu').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );

    // STORE DROPDOWN TOGGLE — THIS IS THE KEY PART
    this.querySelectorAll('.store-dropdown__toggle').forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();    // ← prevents drawer from closing
        e.preventDefault();     // ← prevents any default behavior

        const storeDropdown = toggle.closest('.store-dropdown');
        const isOpen = storeDropdown.classList.contains('open');

        // Close all other open store dropdowns (optional, but nice)
        this.querySelectorAll('.store-dropdown.open').forEach((openDd) => {
          if (openDd !== storeDropdown) openDd.classList.remove('open');
        });

        // Toggle current one
        storeDropdown.classList.toggle('open', !isOpen);

        // Update aria-expanded for accessibility
        toggle.setAttribute('aria-expanded', !isOpen);
      });
    });

    // Optional: Close store dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.store-dropdown')) {
        this.querySelectorAll('.store-dropdown.open').forEach((dd) => {
          dd.classList.remove('open');
          dd.querySelector('.store-dropdown__toggle')?.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (detailsElement.closest('accordion-animated')) {
      if (isOpen) {
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      } else {
        detailsElement.querySelector('summary').setAttribute('aria-expanded', true);
      }
      return;
    }

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      // Inline accordion submenu. The native <details> click toggles the `open`
      // attribute synchronously; we hijack the close case (preventDefault, then
      // animate, then remove `open` on transitionend) and animate height in JS so
      // both open and close are smooth.
      // Drive open/close entirely in JS so the height animation isn't fought by
      // the native <details> toggle.
      event.preventDefault();

      if (isOpen) {
        this.closeSubmenu(detailsElement);
        return;
      }

      // Accordion: only one top-level submenu open at a time. Close any open
      // sibling before opening this one.
      if (detailsElement.classList.contains('main-links')) {
        this.querySelectorAll(':scope details.main-links[open]').forEach((openSibling) => {
          if (openSibling !== detailsElement) this.closeSubmenu(openSibling);
        });
      }

      detailsElement.classList.add('menu-opening');
      summaryElement.setAttribute('aria-expanded', true);
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
      this.openSubmenu(detailsElement);

      !reducedMotion || reducedMotion.matches
        ? addTrapFocus()
        : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
    }
  }

  getDurationMs() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--duration-default').trim();
    const ms = raw.endsWith('ms') ? parseFloat(raw) : parseFloat(raw) * 1000;
    return Number.isFinite(ms) && ms > 0 ? ms : 200;
  }

  openSubmenu(detailsElement) {
    const submenu = detailsElement.querySelector(':scope > .menu-drawer__submenu');
    if (!submenu) {
      detailsElement.setAttribute('open', '');
      return;
    }

    // Ensure `open` is set so the submenu content has layout, measure the
    // natural height FIRST, then collapse to 0 and animate up to it.
    detailsElement.setAttribute('open', '');
    submenu.style.overflow = 'hidden';
    submenu.style.height = 'auto';
    const targetHeight = submenu.scrollHeight;
    submenu.style.height = '0px';

    // Cleanup: drop inline styles so the submenu sizes naturally once open.
    // Guaranteed to run even if `transitionend` never fires.
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      submenu.style.transition = '';
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.removeEventListener('transitionend', onEnd);
    };
    const onEnd = (e) => {
      if (e.target === submenu && e.propertyName === 'height') finish();
    };
    submenu.addEventListener('transitionend', onEnd);

    // Force the browser to commit height:0 (read layout), THEN set the
    // transition + target in the next frame so the 0 → height change animates.
    void submenu.offsetHeight;
    requestAnimationFrame(() => {
      submenu.style.transition = `height ${this.getDurationMs()}ms ease`;
      requestAnimationFrame(() => {
        submenu.style.height = `${targetHeight}px`;
      });
    });

    setTimeout(finish, this.getDurationMs() + 80);
  }

  openMenuDrawer(summaryElement) {
    // Remove then re-add class across animation frames to ensure the
    // CSS transition on `transform` is triggered reliably.
    this.mainDetailsToggle.classList.remove('menu-opening');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden`);
    const summaryElement = this.mainDetailsToggle.querySelector('summary');
    summaryElement.setAttribute('aria-expanded', false);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');

    // A close button inside a submenu just collapses that submenu. The main
    // drawer's close button must run the full close path (closeMenuDrawer),
    // otherwise the body's `overflow-hidden` scroll lock is never removed.
    if (detailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }

    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));

    const submenu = detailsElement.querySelector(':scope > .menu-drawer__submenu');
    if (!submenu) {
      detailsElement.removeAttribute('open');
      return;
    }

    // Animate height from current → 0, then drop the `open` attribute so the
    // collapse is visible (native <details> would otherwise hide content instantly).
    submenu.style.overflow = 'hidden';
    submenu.style.height = `${submenu.scrollHeight}px`;

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      submenu.removeEventListener('transitionend', onEnd);
      detailsElement.removeAttribute('open');
      submenu.style.transition = '';
      submenu.style.height = '';
      submenu.style.overflow = '';
    };
    const onEnd = (e) => {
      if (e.target === submenu && e.propertyName === 'height') finish();
    };
    submenu.addEventListener('transitionend', onEnd);

    requestAnimationFrame(() => {
      submenu.style.transition = `height ${this.getDurationMs()}ms ease`;
      requestAnimationFrame(() => {
        submenu.style.height = '0px';
      });
    });

    setTimeout(finish, this.getDurationMs() + 80);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.headerWrapper = document.querySelector('.header-wrapper');
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    if (this.headerWrapper?.getAttribute('data-header-version') === 'transparent') {
      this.headerWrapper.classList.remove('transparent'); // typo!
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    const currentScrollY = window.scrollY;
    const pastThreshold = currentScrollY > 100;
    if (this.headerWrapper?.getAttribute('data-header-version') === 'transparent' && !pastThreshold) {
      this.headerWrapper.classList.add('transparent'); // typo!
    }
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    // Close button
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );

    // Escape key
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.isClosing = false;
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    // Lock body scroll while modal is open
    this._scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('overflow-hidden');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    this.setAttribute('open', '');
    // Delay adding the class to trigger the transition
    requestAnimationFrame(() => {
      this.classList.add('opening');
    });

    if (popup) popup.loadContent();
    // trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.isClosing = true;
    this.classList.remove('opening');

    let isCleanedUp = false;

    const cleanup = () => {
      if (isCleanedUp || !this.isClosing) return;
      isCleanedUp = true;
      this.isClosing = false;

      // Restore body scroll
      document.body.classList.remove('overflow-hidden');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';

      if (typeof this._scrollY === 'number') {
        window.scrollTo(0, this._scrollY);
      }

      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      // removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    };

    // Wait for the transition to finish before removing the attribute
    this.addEventListener('transitionend', (event) => {
      if (event.target === this) {
        cleanup();
      }
    }, { once: true });

    // Fallback in case transitionend doesn't fire
    setTimeout(cleanup, 500);
  }
}

customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;

    let startX = 0;
    let startY = 0;
    let isDragging = false;
    const DRAG_THRESHOLD = 8; // px

    this.addEventListener('pointerdown', (e) => {
      startX = e.clientX;
      startY = e.clientY;
      isDragging = false;
    });

    this.addEventListener('pointermove', (e) => {
      // Only detect drag if pointer is still down and hasn't moved too far
      if (
        Math.abs(e.clientX - startX) > DRAG_THRESHOLD ||
        Math.abs(e.clientY - startY) > DRAG_THRESHOLD
      ) {
        isDragging = true;
      }
    });


    this.addEventListener('click', (e) => {
      // Only prevent if user was actually dragging the button itself
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(this);
    });
  }
}

customElements.define('modal-opener', ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.closest('section')?.querySelectorAll('.no-size__error--msg').forEach((el) => el.classList.add('hidden'));

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // Prevent abandoned variant updates
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const updateAll = (selector, callback) => {
          document.querySelectorAll(selector).forEach(callback);
        };

        const getSource = (id) => html.getElementById(id);

        /* ================= PRICE ================= */
        const priceSource = html.querySelector(
          `[data-price-for="${sectionId}"]`
        );
        if (priceSource) {
          updateAll(
            `[data-price-for="${this.dataset.section}"]`,
            (el) => {
              el.className = priceSource.className;
              el.innerHTML = priceSource.innerHTML;
              el.classList.remove('hidden');
            }
          );
        }

        /* ================= SKU ================= */
        const skuSource = getSource(`Sku-${sectionId}`);
        if (skuSource) {
          updateAll(`[id="Sku-${this.dataset.section}"]`, (el) => {
            el.innerHTML = skuSource.innerHTML;
            el.classList.toggle('hidden', skuSource.classList.contains('hidden'));
          });
        }

        /* ================= INVENTORY ================= */
        const inventorySource = getSource(`Inventory-${sectionId}`);
        if (inventorySource) {
          updateAll(`[id="Inventory-${this.dataset.section}"]`, (el) => {
            el.innerHTML = inventorySource.innerHTML;
            el.classList.toggle('hidden', inventorySource.innerText === '');
          });
        }

        /* ================= BADGE ================= */
        const badgeSource = getSource(`ProductBadge-${sectionId}`);
        if (badgeSource) {
          updateAll(`[id="ProductBadge-${this.dataset.section}"]`, (el) => {
            el.innerHTML = badgeSource.innerHTML;
          });
        }

        /* ================= VOLUME PRICING ================= */
        const volumeSource = getSource(`Volume-${sectionId}`);
        if (volumeSource) {
          updateAll(`[id="Volume-${this.dataset.section}"]`, (el) => {
            el.innerHTML = volumeSource.innerHTML;
            el.classList.remove('hidden');
          });
        }

        updateAll(`[id="Quantity-Rules-${this.dataset.section}"]`, (el) =>
          el.classList.remove('hidden')
        );

        updateAll(`[id="Volume-Note-${this.dataset.section}"]`, (el) =>
          el.classList.remove('hidden')
        );

        /* ================= PRICE PER ITEM ================= */
        const pricePerItemSource = getSource(`Price-Per-Item-${sectionId}`);
        if (pricePerItemSource) {
          updateAll(`[id="Price-Per-Item-${this.dataset.section}"]`, (el) => {
            el.innerHTML = pricePerItemSource.innerHTML;
            el.classList.toggle(
              'hidden',
              pricePerItemSource.classList.contains('hidden')
            );
          });
        }

        /* ================= ADD TO CART BUTTON ================= */
        const addButtonSource = getSource(`ProductSubmitButton-${sectionId}`);
        if (addButtonSource) {
          updateAll(
            `[id="ProductSubmitButton-${this.dataset.section}"]`,
            (button) => {
              const spanDest = button.querySelector('span');
              const spanSource = addButtonSource.querySelector('span');

              if (spanDest && spanSource) {
                spanDest.textContent = spanSource.textContent;
              }

              if (addButtonSource.hasAttribute('disabled')) {
                button.setAttribute('disabled', '');
              } else {
                button.removeAttribute('disabled');
              }
            }
          );
        }

        /* ================= PREORDER NOTE ================= */
        const preOrderSource = getSource(`preOrderNote-${sectionId}`);
        if (preOrderSource) {
          updateAll(`[id="preOrderNote-${this.dataset.section}"]`, (el) => {
            el.innerHTML = preOrderSource.innerHTML;
            el.classList.toggle(
              'hidden',
              preOrderSource.classList.contains('hidden')
            );
          });
        }

        /* ================= VARIANT RADIOS ================= */
        // Skip replacing variant-radios in Quick Add modal - cloneNode doesn't re-run
        // constructor so event listeners are lost, breaking subsequent variant selection
        if (!this.dataset.originalSection) {
          const radiosSource = getSource(`variant-radios-${sectionId}`);
          if (radiosSource) {
            updateAll(
              `[id="variant-radios-${this.dataset.section}"]`,
              (destination) => {
                const clone = radiosSource.cloneNode(true);
                destination.replaceWith(clone);

                customElements.whenDefined('variant-radios').then(() => {
                  clone.connectedCallback();
                });
              }
            );
          }
        }

        /* ================= KLAVIYO FORM ================= */
        const klaviyoSource = getSource(`klaviyo-form-${sectionId}`);
        if (klaviyoSource) {
          updateAll(`[id="klaviyo-form-${this.dataset.section}"]`, (el) => {
            const clone = klaviyoSource.cloneNode(true);
            el.parentNode.replaceChild(clone, el);
          });
        }

        /* ================= EVENT ================= */
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const prices = document.querySelectorAll(
      `[data-price-for="${this.dataset.section}"]`
    );
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    prices.forEach((price) => price.classList.add('hidden'));
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // In Theme Editor, section re-renders can already include fresh markup.
    // Avoid re-fetching and replacing that markup with stale/cached response.
    if (window.Shopify && window.Shopify.designMode && this.innerHTML.trim().length) {
      if (this.querySelector('.grid__item')) {
        this.classList.add('product-recommendations--loaded');
      }
      this.dispatchEvent(
        new CustomEvent('product-recommendations:loaded', {
          bubbles: true,
          detail: { recommendationsEl: this },
        })
      );
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const url = new URL(this.dataset.url, window.location.origin);
      if (window.Shopify && window.Shopify.designMode) {
        url.searchParams.set('_theme_editor_ts', Date.now().toString());
      }

      fetch(url.toString(), { cache: 'no-store' })
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('.complementary-swiper-container') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          this.dispatchEvent(
            new CustomEvent('product-recommendations:loaded', {
              bubbles: true,
              detail: { recommendationsEl: this },
            })
          );
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('product-recommendations:loaded', (event) => {
  const recEl = event.detail.recommendationsEl;
  const containerEl = recEl.querySelector('.complementary-swiper-container');
  if (!containerEl) return;

  function initComplementarySwiper() {
    const swiperEl = containerEl.querySelector('.complementary-swiper');
    const prevBtn = containerEl.querySelector('.comp-swiper-prev');
    const nextBtn = containerEl.querySelector('.comp-swiper-next');
    const counterEl = containerEl.querySelector('.slider-counter--current');
    const paginationBtns = Array.from(containerEl.querySelectorAll('.comp-swiper-pagination .slider-counter__link'));

    function updatePagination(realIndex) {
      if (counterEl) counterEl.textContent = realIndex + 1;
      paginationBtns.forEach((btn, i) => {
        btn.classList.toggle('slider-counter__link--active', i === realIndex);
      });
    }

    const SwiperLib = window.Swiper;
    const swiper = new SwiperLib(swiperEl, {
      slidesPerView: 1,
      loop: false,
      // Height follows the active slide instead of locking to the tallest
      // slide measured at init (before lazy images load) — that stale short
      // height was clipping the card price on mobile.
      autoHeight: true,
      navigation: { prevEl: prevBtn, nextEl: nextBtn },
      mousewheel: { enabled: true, forceToAxis: true, releaseOnEdges: true },
      touchReleaseOnEdges: true,
      on: {
        slideChange: function () {
          updatePagination(this.activeIndex);
        },
      },
    });

    // Recalculate once images finish loading so the height matches the real
    // card size (lazy images have no dimensions at init time).
    swiperEl.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => swiper.updateAutoHeight(0), { once: true });
      img.addEventListener('error', () => swiper.updateAutoHeight(0), { once: true });
    });
    window.addEventListener('load', () => swiper.updateAutoHeight(0), { once: true });

    paginationBtns.forEach((btn, i) => {
      btn.addEventListener('click', () => swiper.slideTo(i));
    });
  }

  if (typeof window.Swiper !== 'undefined') {
    initComplementarySwiper();
  } else {
    const swiperScript = document.querySelector('script[src*="swiper"]');
    if (swiperScript) swiperScript.addEventListener('load', initComplementarySwiper);
  }
});

// GeoIP Country Redirect app pop-up hide body scroll

function waitForModal() {
  const findModal = setInterval(() => {
    const modal = document.querySelector('#sg_country_redirect_mod');
    if (modal) {
      clearInterval(findModal);
      let lastState = null;
      const checkVisibility = setInterval(() => {
        const isVisible = window.getComputedStyle(modal).display === "block";
        if (isVisible !== lastState) {
          document.body.style.overflow = isVisible ? "hidden" : "auto";
          lastState = isVisible;
        }
      }, 300);
    }
  }, 300);
}
document.addEventListener("DOMContentLoaded", waitForModal);

function openModal() {
  const modal = document.getElementById("sg_country_redirect_mod");
  if (!modal) return;
  modal.style.display = "block";
  modal.classList.add("in");
  modal.classList.remove("fade");
}

function closeModal() {
  const modal = document.getElementById("sg_country_redirect_mod");
  if (!modal) return;
  modal.style.display = "none";
  modal.classList.remove("in");
}

window.addEventListener("DOMContentLoaded", () => {
  openModal();

  const btnYes = document.getElementById("spicegems_cr_btn_yes");
  const btnNo = document.getElementById("spicegems_cr_btn_no");

  if (btnYes) btnYes.addEventListener("click", closeModal);
  if (btnNo) btnNo.addEventListener("click", closeModal);
});




class ScrollingAnnouncement extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed),
      space: 100,
    };

    this.promotion = this.querySelector('.promotion');
    this.isTouching = false;
    this.scrollTimeout = null;

    this.init();

    const announcementBar = this.closest('.utility-bar');
    document.documentElement.style.setProperty(
      '--anouncement-scroll-height',
      announcementBar ? `${announcementBar.offsetHeight}px` : '0'
    );
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      // Clone enough items for looping
      for (let i = 0; i < 20; i++) {
        const clone = this.promotion.cloneNode(true);
        clone.setAttribute('aria-hidden', true);
        const img = clone.querySelector('.promotion__item');
        if (img) img.classList.remove('loading');
        this.appendChild(clone);
      }

      const animationTimeFrame = this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      if (this.classList.contains('icons-section__icons-wrapper')) {
        // Disable scroll completely
        this.style.overflowX = 'hidden';
        this.style.overflowY = 'hidden';
        this.style.webkitOverflowScrolling = 'touch'; // Smooth scrolling on iOS
      } else {
        // Default scrolling behavior
        this.style.overflowX = 'auto';
        this.style.overflowY = 'hidden';
        this.style.webkitOverflowScrolling = 'touch'; // Smooth scrolling on iOS
      }

      // Center the first slide on load 
      // const firstItem = this.querySelector('.promotion__item');
      // if (firstItem) {
      //   const itemWidth = firstItem.offsetWidth;
      //   const containerWidth = this.offsetWidth;
      //   const itemLeft = firstItem.offsetLeft;
      //   // Center the item: scroll to position where item center aligns with container center
      //   let scrollPosition = itemLeft + (itemWidth / 2) - (containerWidth / 2);
      //   console.log(containerWidth,"containerWidthcontainerWidth");
      //   // Convert negative to positive
      //   scrollPosition = Math.abs(scrollPosition);
      //   scrollPosition = scrollPosition + containerWidth + 36 ;
      //   console.log(scrollPosition,"scrollPositionscrollPosition");
      //   this.scrollLeft = scrollPosition;
      // } 

      // Intersection play/pause
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            entry.isIntersecting ? this.scrollingPlay() : this.scrollingPause();
          });
        },
        { rootMargin: '0px 0px 50px 0px' }
      );
      observer.observe(this);

      // Pause on hover
      this.addEventListener('mouseenter', () => this.scrollingPause());
      this.addEventListener('mouseleave', () => this.scrollingPlay());
      this.closest('.utility-bar')?.addEventListener('mouseenter', () => this.scrollingPause());
      this.closest('.utility-bar')?.addEventListener('mouseleave', () => this.scrollingPlay());

      // Touch handling
      this.addEventListener('touchstart', () => {
        this.isTouching = true;
        this.scrollingPause();
      });

      this.addEventListener('touchend', () => {
        this.isTouching = false;
        setTimeout(() => {
          if (!this.isTouching) this.scrollingPlay();
        }, 900);
      });

      // Infinite scroll loop
      this.addEventListener('touchstart', () => {
        this.scrollingPause();

        const visible = this.clientWidth;
        const singleWidth = this.promotion.offsetWidth;

        // Loop right smoothly
        if (this.scrollLeft >= (this.scrollWidth - visible - singleWidth)) {
          this.scrollLeft -= singleWidth;
        }

        // Loop left smoothly
        if (this.scrollLeft <= singleWidth) {
          this.scrollLeft += singleWidth;
        }

        // Resume animation after user stops interacting
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          if (!this.isTouching) this.scrollingPlay();
        }, 900);
      });
    }
  }


  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}

customElements.define('scrolling-announcement', ScrollingAnnouncement);


class ScrollingSlider extends HTMLElement {
  constructor() {
    super();

    this.config = {
      moveTime: parseFloat(this.dataset.speed),
      space: 100,
    };

    this.promotion = this.querySelector('.promotion');
    this.isTouching = false;
    this.init();
  }

  init() {
    if (this.childElementCount === 1) {
      this.promotion.classList.add('promotion--animated');

      for (let index = 0; index < 20; index++) {
        this.clone = this.promotion.cloneNode(true);
        this.clone.setAttribute('aria-hidden', true);
        this.appendChild(this.clone);

        const imageWrapper = this.clone.querySelector('.promotion__item');
        if (imageWrapper) {
          imageWrapper.classList.remove('loading');
        }
      }

      const animationTimeFrame = this.config.moveTime;
      this.style.setProperty('--duration', `${animationTimeFrame}s`);

      if (this.classList.contains('icons-section__icons-wrapper')) {
        // Disable scroll completely
        this.style.overflowX = 'hidden';
        this.style.overflowY = 'hidden';
        this.style.webkitOverflowScrolling = 'touch'; // Smooth scrolling on iOS
      } else {
        // Default scrolling behavior
        this.style.overflowX = 'auto';
        this.style.overflowY = 'hidden';
        this.style.webkitOverflowScrolling = 'touch'; // Smooth scrolling on iOS
      }

      // Pause when out of view
      const observer = new IntersectionObserver((entries, _observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.scrollingPlay();
          } else {
            this.scrollingPause();
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      observer.observe(this);

      // Pause on hover
      this.addEventListener('mouseenter', () => this.scrollingPause());
      this.addEventListener('mouseleave', () => this.scrollingPlay());
      this.closest('.utility-bar')?.addEventListener('mouseenter', () => this.scrollingPause());
      this.closest('.utility-bar')?.addEventListener('mouseleave', () => this.scrollingPlay());

      // Touch events for gesture scrolling
      this.addEventListener('touchstart', () => {
        this.isTouching = true;
        this.scrollingPause();
      });

      this.addEventListener('touchend', () => {
        this.isTouching = false;
        // Resume auto-scroll after a short delay
        setTimeout(() => {
          if (!this.isTouching) {
            this.scrollingPlay();
          }
        }, 1000);
      });

      // Also pause during scroll gesture
      this.addEventListener('scroll', () => {
        this.scrollingPause();

        // Clear existing timeout
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }

        // Resume auto-scroll after user stops scrolling
        this.scrollTimeout = setTimeout(() => {
          if (!this.isTouching) {
            this.scrollingPlay();
          }
        }, 1000);
      });
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-slider', ScrollingSlider);

// Header solid/transparent  js

function initHeaderTransparencyScript() {
  window.removeEventListener("scroll", updateHeaderTransparencySafe);
  document.removeEventListener("toggle", updateHeaderTransparencySafe, true);

  function getElements() {
    return {
      header: document.querySelector(".header-wrapper"),
      menu: document.querySelector("#Details-menu-drawer-container"),
      firstBanner: document
        .querySelector("main > .shopify-section")
        ?.querySelector(".header-version")
    };
  }

  // ---------------------------------------
  // SET HEADER VERSION ONCE (PAGE LOAD ONLY)
  // ---------------------------------------
  function setHeaderVersionOnce() {
    const { header, firstBanner } = getElements();
    if (!header) return;

    // Do not overwrite if already set
    if (header.dataset.headerVersion) return;

    if (!firstBanner || firstBanner.classList.contains("solid")) {
      header.dataset.headerVersion = 'solid';
    } else {
      header.dataset.headerVersion = 'transparent';
    }

    // Remove the inline opacity hide — CSS transition takes over from here
    header.style.opacity = '';
  }

  setHeaderVersionOnce();

  let lastScrollY = window.scrollY;
  let hasScrolledDown = false;

  function updateHeaderTransparencySafe() {
    const { header, menu, firstBanner } = getElements();
    if (!header) return;

    const body = document.body;
    const menuIsOpen = menu && menu.classList.contains("menu-opening");
    const megaMenuOpen = body.classList.contains("megamenu-open");

    const currentScrollY = window.scrollY;
    const pastThreshold = currentScrollY > 100;

    // ---------------------------------------
    // FORCE SOLID WHEN MENU IS OPEN
    // ---------------------------------------
    if (megaMenuOpen || menuIsOpen) {
      header.classList.remove("transparent");
      header.classList.add("solid");
      lastScrollY = currentScrollY;
      return;
    }

    // ---------------------------------------
    // NO BANNER OR SOLID BANNER → SOLID
    // ---------------------------------------
    if (!firstBanner || firstBanner.classList.contains("solid")) {
      header.classList.remove("transparent");
      header.classList.add("solid");
      lastScrollY = currentScrollY;
      return;
    }

    // ---------------------------------------
    // BANNER IS TRANSPARENT
    // ---------------------------------------

    // Detect scroll direction reliably
    if (currentScrollY > lastScrollY) {
      // SCROLLING DOWN
      hasScrolledDown = true;

      // header.classList.add("transparent");
      // header.classList.remove("solid");

    } else if (currentScrollY < lastScrollY) {
      // SCROLLING UP

      if (hasScrolledDown && pastThreshold) {
        header.classList.add("solid");
        header.classList.remove("transparent");
      } else {
        header.classList.add("transparent");
        header.classList.remove("solid");
      }
    }

    lastScrollY = currentScrollY;
  }

  // 🔹 INITIAL LOAD
  const { header, firstBanner } = getElements();
  if (header && firstBanner && !firstBanner?.classList.contains("solid")) {
    if (window.scrollY > 100) {
      header.classList.add("solid");
      header.classList.remove("transparent");
    } else {
      header.classList.add("transparent");
      header.classList.remove("solid");
    }
  }

  function setMarginToFirst() {
    const { firstBanner } = getElements();
    firstBanner?.classList.add('is-first-section')
  }
  setMarginToFirst();

  window.addEventListener("scroll", updateHeaderTransparencySafe);
  document.addEventListener("toggle", updateHeaderTransparencySafe, true);
}

document.addEventListener("DOMContentLoaded", initHeaderTransparencyScript);



// Re-init in theme editor
if (Shopify.designMode) {
  const designEvents = [
    "shopify:section:load",
    "shopify:section:unload",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:block:select",
    "shopify:block:deselect"
  ];

  designEvents.forEach((event) => {
    document.addEventListener(event, initHeaderTransparencyScript);
    if (typeof runInitAfterDOMUpdate === 'function') {
      document.addEventListener(event, runInitAfterDOMUpdate);
    }
  });
}


document.addEventListener("DOMContentLoaded", () => {
  const headerWrapper = document.querySelector(".header-group");

  if (!headerWrapper) return;

  // Mark page as having a fixed header
  document.documentElement.classList.add("has-fixed-headerWrapper");

  // Ensure header is fixed and animates via top
  headerWrapper.style.position = "fixed";
  headerWrapper.style.top = "0";
  headerWrapper.style.left = "0";
  headerWrapper.style.right = "0";
  headerWrapper.style.willChange = "top";
  headerWrapper.style.transition = "top 0.5s ease-in-out";

  let prevY = window.pageYOffset;
  let ticking = false;

  // Helper: set sticky offset
  const setHeaderOffset = (value) => {
    document.documentElement.style.setProperty("--header-offset", value);
  };

  // Helper: toggle hidden class
  const setHeaderVisibilityClass = (isHidden) => {
    if (isHidden) {
      headerWrapper.classList.add("header-hidden");
    } else {
      headerWrapper.classList.remove("header-hidden");
    }
  };

  // Initial offset (header visible)
  setHeaderOffset(
    "calc(var(--notification-bar-height) + var(--header-height))"
  );
  setHeaderVisibilityClass(false);

  const handleScroll = () => {
    const currentY = window.pageYOffset;
    const headerHeight = headerWrapper.offsetHeight;
    const deltaY = currentY - prevY;

    // When APC jump accordion is open, disable header hide/show animation
    const apcJumpAccordion = document.querySelector(
      ".apc-jump-list-mobile details"
    );
    if (apcJumpAccordion?.hasAttribute("open")) {
      prevY = currentY;
      ticking = false;
      return;
    }

    // When megamenu is open, keep header visible — no fluctuation
    const megamenuOpen =
      document.body.classList.contains("megamenu-open") ||
      !!document.querySelector("header-megamenu details[open]");
    if (megamenuOpen) {
      headerWrapper.style.top = "0";
      setHeaderVisibilityClass(false);
      prevY = currentY;
      ticking = false;
      return;
    }

    // Near top → always show header
    if (currentY < 100) {
      headerWrapper.style.top = "0";
      setHeaderOffset(
        "calc(var(--notification-bar-height) + var(--header-height))"
      );
      setHeaderVisibilityClass(false);
    }
    // Scrolling down enough → hide header
    else if (deltaY > 10) {
      headerWrapper.style.top = `-${headerHeight}px`;
      setHeaderVisibilityClass(true);
    }
    // Scrolling up enough → show header
    else if (deltaY < -10) {
      headerWrapper.style.top = "0";
      setHeaderOffset(
        "calc(var(--notification-bar-height) + var(--header-height))"
      );
      setHeaderVisibilityClass(false);
    }

    prevY = currentY;
    ticking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(handleScroll);
        ticking = true;
      }
    },
    { passive: true }
  );
});



// class SvgImage extends HTMLElement {
//   constructor() {
//     super();
//     this.convertImage();

//   }
//   convertImage() {

//     const mainDiv = this.querySelector(".icons-section-media");
//     const iamgeUrl = mainDiv?.getAttribute("data-image-url");
//     if (iamgeUrl) {
//       fetch(iamgeUrl)
//         .then(response => {
//           if (!response.ok) throw new Error("Network response was not ok");
//           return response.text();
//         })
//         .then(svgText => {
//           mainDiv.innerHTML = svgText;

//         })
//         .catch(error => {
//           console.error('Error fetching SVG:', error);
//         });
//     }
//   }
// }
// customElements.define('svg-image', SvgImage);

document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', (event) => {
    if (event.target.closest('.menu-drawer__header-close')) {
      const details = document.getElementById('Details-menu-drawer-container');
      const summary = document.querySelector('.header__icon--summary');

      if (!details || !summary) return;

      // 1. Clean up states (match closeMenuDrawer)
      details.classList.remove('menu-opening');
      document.body.classList.remove(
        ...Array.from(document.body.classList).filter(cls => cls.startsWith('overflow-hidden-'))
      );

      // 2. Close all submenus (optional but clean)
      details.querySelectorAll('details').forEach(d => {
        d.removeAttribute('open');
        d.classList.remove('menu-opening', 'submenu-open');
      });
      details.querySelectorAll('.submenu-open').forEach(el => {
        el.classList.remove('submenu-open');
      });

      // 3. Update aria and focus intent
      summary.setAttribute('aria-expanded', 'false');

      // 4. 🔁 REPLICATE THE EXACT closeAnimation FROM YOUR CLASS
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          // Animation done — fully close
          details.removeAttribute('open');
          summary.focus();
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  });

  const notificationBar = document.querySelector('.notification-bar');
  const height = notificationBar ? notificationBar.offsetHeight : 0;

  document.documentElement.style.setProperty('--notification-bar-height', `${height}px`);


  const navTopContainers = document.querySelectorAll('.menu-drawer__navigation-top');

  navTopContainers.forEach(function (navTop) {
    const detailsList = navTop.querySelectorAll('.menu-drawer__navigation details');
    const banner = navTop.querySelector('.menu-drawer__banner');

    if (detailsList.length === 0) return;

    // Close all details except the one being opened
    function closeOtherDetails(openingDetail) {
      detailsList.forEach(detail => {
        if (detail !== openingDetail) {
          detail.open = false;
        }
      });
    }

    // Update banner visibility based on any open state
    function updateBannerVisibility() {
      const isOpen = Array.from(detailsList).some(detail => detail.open);
      if (banner) {
        banner.style.display = isOpen ? 'none' : '';
      }
    }

    // Attach event listeners
    detailsList.forEach(function (detail) {
      detail.addEventListener('click', function () {
        // If this detail is being closed (user clicked summary again), don't auto-reopen others
        // But we still need to check if it's transitioning to closed
        if (detail.open) {
          // It's about to close – do nothing here; 'toggle' will handle banner
        } else {
          // It's being opened – close others first
          closeOtherDetails(detail);
        }
        // Update banner after state change (use toggle event to be safe)
      });

      // Use 'toggle' event to reliably catch open/close state
      detail.addEventListener('toggle', updateBannerVisibility);
    });

    // Initial banner state
    updateBannerVisibility();
  });
});

class AccordionAnimated extends HTMLElement {
  constructor() {
    super();

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    // Bind once
    this.handleClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.setup();
  }

  refresh() {
    this.teardown();
    this.setup();
  }

  setup() {
    this.details = this.querySelector("details");
    if (!this.details) return;

    this.summary = this.details.querySelector("summary");
    this.content = this.details.querySelector(".accordion__content");
    if (!this.summary || !this.content) return;

    this.summary.addEventListener("click", this.handleClick);
  }

  teardown() {
    if (this.summary) {
      this.summary.removeEventListener("click", this.handleClick);
    }

    if (this.animation) {
      this.animation.cancel();
      this.animation = null;
    }
  }

  onClick(event) {
    event.preventDefault();

    // Anchor on the clicked summary: whatever the toggle does — close a sibling
    // above (removing its height), focus-scroll the summary into view, scroll
    // anchoring — keep THIS summary at the same spot in the viewport. This
    // single correction covers every "jump" case instead of fighting them.
    const summaryTopBefore = this.summary.getBoundingClientRect().top;

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.close();
    }

    const summaryTopAfter = this.summary.getBoundingClientRect().top;
    const delta = summaryTopAfter - summaryTopBefore;
    if (delta !== 0) {
      window.scrollBy(0, delta);
    }
  }

  closeSiblingAccordions() {
    const groupName = this.details.getAttribute("data-accordion-group");
    if (!groupName) return;

    // Scroll compensation for any height removed above is handled by the
    // summary-anchor in onClick(); here we just collapse the siblings.
    document
      .querySelectorAll('details[data-accordion-group][open]')
      .forEach((openDetails) => {
        if (openDetails.getAttribute("data-accordion-group") !== groupName) return;
        if (openDetails === this.details) return;

        const openSummary = openDetails.querySelector("summary");
        if (openSummary) {
          openSummary.setAttribute("aria-expanded", "false");
        }

        const accordionHost = openDetails.closest("accordion-animated");
        if (accordionHost && accordionHost.animation) {
          accordionHost.animation.cancel();
          accordionHost.animation = null;
          accordionHost.isClosing = false;
          accordionHost.isExpanding = false;
        }

        openDetails.removeAttribute("open");
        openDetails.style.height = "";
        openDetails.style.overflow = "";
      });
  }

  open() {
    this.closeSiblingAccordions();

    this.details.style.overflow = "hidden";
    this.details.open = true;
    this.summary.setAttribute("aria-expanded", "true");

    const startHeight = this.summary.offsetHeight;
    const endHeight = startHeight + this.content.offsetHeight;

    this.isExpanding = true;

    this.animation = this.details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: 280, easing: "ease" }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  close() {
    this.details.style.overflow = "hidden";

    const startHeight = this.details.offsetHeight;
    const endHeight = this.summary.offsetHeight;

    this.summary.setAttribute("aria-expanded", "false");
    this.isClosing = true;

    this.animation = this.details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: 280, easing: "ease" }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.details.style.height = "";
    this.details.style.overflow = "";

    this.isClosing = false;
    this.isExpanding = false;
  }
}

customElements.define("accordion-animated", AccordionAnimated);


document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector("#ContactFooter, #contactfooter");
  if (!form) return;

  const emailInput = form.querySelector('input[name="contact[email]"]');
  const submitButton = form.querySelector('button[type="submit"]');
  const errorMsg = form.querySelector(".newsletter-error");
  if (!emailInput || !submitButton || !errorMsg) return;

  function showError() {
    errorMsg.style.display = "block";
    emailInput.classList.add("input-error");
    submitButton.disabled = true;
  }

  function hideError() {
    errorMsg.style.display = "none";
    emailInput.classList.remove("input-error");
    submitButton.disabled = false;
  }


  emailInput.addEventListener("focus", hideError);

  form.addEventListener("submit", function (e) {
    const email = emailInput.value.trim();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (email === "") {
      e.preventDefault();
      showError();
      return false;
    }

    if (!valid) {
      return true;
    }

    submitButton.disabled = true;
  });

});

// store dropdowns

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".store-dropdown").forEach(dropdown => {
    const toggle = dropdown.querySelector(".store-dropdown__toggle");
    const labelEl = toggle.querySelector(".store-dropdown__label");
    const iconWrapper = toggle.querySelector(".store-dropdown__icon ");
    const iconDiv = toggle.querySelector(".icons-section__left-media.icons-section-media");
    const items = dropdown.querySelectorAll(".store-dropdown__item");
    let activeItem = null;
    const saved = localStorage.getItem("selected_store_url");

    if (saved) {
      activeItem = dropdown.querySelector(`.store-dropdown__item[data-store-url="${saved}"]`);
    }
    if (!activeItem) {
      activeItem = dropdown.querySelector(".store-dropdown__item.active") || items[0];
    }


    function updateToggle(item) {
      if (!item) return;
      labelEl.textContent = item.dataset.label || "Store";
      const sourceSvgImage = item.querySelector("svg-image");
      if (sourceSvgImage && iconWrapper) {
        iconWrapper.innerHTML = sourceSvgImage.innerHTML;
      }
      // Save
      localStorage.setItem("selected_store_url", item.dataset.storeUrl);
    }

    if (activeItem) updateToggle(activeItem);

    items.forEach(item => {
      item.addEventListener("click", e => {
        e.preventDefault();
        updateToggle(item);
        dropdown.classList.remove("open");
        setTimeout(() => location.href = item.href, 200);
      });
    });
  });


  document.addEventListener("click", e => {
    document.querySelectorAll(".store-dropdown").forEach(dd => {
      const btn = dd.querySelector(".store-dropdown__toggle");
      if (btn && btn.contains(e.target)) {
        dd.classList.toggle("open");
      } else if (!dd.contains(e.target)) {
        dd.classList.remove("open");
      }
    });
  });
});
class ProductCard extends HTMLElement {
  connectedCallback() {
    this.swiperEl = this.querySelector(".swiper");
    if (!this.swiperEl) return;
    const articleParent = this.closest('.article-main-carousel');
    if (!articleParent) {
      this.initializeSwiper();
    }
    this.observeMainImageWidth();
  }

  initializeSwiper() {
    // Prevent double initialization
    if (this.swiper) return;
    if (!window.Swiper) {
      setTimeout(() => this.initializeSwiper(), 100);
      return;
    }

    const isMobile = matchMedia("(max-width: 1023px)").matches;
    this.swiper = new Swiper(this.swiperEl, {
      loop: true,
      slidesPerView: 'auto',
      simulateTouch: true,
      grabCursor: true,
      nested: true,
      observer: true,
      observeParents: true,
      touchReleaseOnEdges: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true
      },
      spaceBetween: 1,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },

      navigation: {
        nextEl: this.swiperEl.querySelector(".swiper-button-next"),
        prevEl: this.swiperEl.querySelector(".swiper-button-prev"),
      },

      on: {
        init: (swiper) => {
          if (!isMobile) {
            this.setupHover(swiper);
          }
          // Ensure pagination is correctly initialized/updated (fixes clashes when nested in other Swipers)
          if (swiper.pagination) {
            try {
              swiper.pagination.init && swiper.pagination.init();
              swiper.pagination.render && swiper.pagination.render();
              swiper.pagination.update && swiper.pagination.update();
            } catch (e) {
              console.warn('Swiper pagination init error', e);
            }
          }
        },
      },
    });

    this.handleResize();
  }

  setupHover(swiper) {
    const slides = [...this.swiperEl.querySelectorAll(".swiper-slide")];
    const mainImage = this.querySelector(".main-slide");
    const falseImageHover = this.querySelector(".false-image");
    const mediaWrapper = this.querySelector(".card__media");
    const mediaMainWapper = this.querySelector('.media__wrapper')

    const mainSlideIndex = slides.findIndex(slide =>
      slide.classList.contains("main-slide")
    );

    const hoverSlideIndex = slides.findIndex(slide =>
      slide.classList.contains("hover-slide")
    );

    if (mainSlideIndex === -1 || hoverSlideIndex === -1 || !mainImage) return;

    let hoverActive = false;

    mainImage.addEventListener("mouseenter", () => {
      if (hoverActive || swiper.realIndex === hoverSlideIndex) return;
      if (window.innerWidth < 1024) return;
      hoverActive = true;
      swiper.slideToLoop(hoverSlideIndex, 0, false);
    });

    falseImageHover.addEventListener("mouseenter", () => {
      falseImageHover.classList.remove("visible-media");
      mediaWrapper.classList.add("visible-media");
    });


    mediaMainWapper.addEventListener("mouseleave", () => {
      falseImageHover.classList.add("visible-media");
      mediaWrapper.classList.remove("visible-media");
      hoverActive = false;
      if (window.innerWidth < 1024) return;
      setTimeout(() => {
        swiper.slideToLoop(mainSlideIndex, 0, false);
      }, 400);
    });
  }
  // NEW: Observe width change
  observeMainImageWidth() {
    const mainImage = this.querySelector(".main-slide");
    if (!mainImage || !window.ResizeObserver) return;

    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const newWidth = entry.contentRect.width;
        this.updateSwiper();
      }
    });

    this.resizeObserver.observe(mainImage);
  }
  // Swiper update method
  updateSwiper() {
    if (this.swiper) {
      this.swiper.update();
      this.swiper.updateSlides();
      this.swiper.updateProgress();
      // Keep pagination in sync (if present)
      if (this.swiper.pagination && this.swiper.pagination.update) {
        this.swiper.pagination.update();
      }
    }
  }

  handleResize() {
    window.addEventListener("resize", () => {
      this.updateSwiper();
    });
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.swiper) {
      try {
        this.swiper.destroy(true, true);
      } catch (e) {
        // ignore
      }
      this.swiper = null;
    }
  }
}

customElements.define("product-card", ProductCard);
class PillsSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector(".swiper");
  }

  connectedCallback() {
    this.initializeSwiper();
  }

  initializeSwiper() {
    if (!window.Swiper) {
      setTimeout(() => this.initializeSwiper(), 100);
      return;
    }

    if (!this.swiperEl) return;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: "auto",
      roundLengths: true,
      simulateTouch: true,
      grabCursor: true,
      touchReleaseOnEdges: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true
      },
      watchOverflow: true,
      spaceBetween: 8,
      slidesOffsetAfter: 0,
      watchOverflow: true
    });

  }
}
customElements.define("pills-swiper", PillsSwiper);

// author-landing-page

document.addEventListener('DOMContentLoaded', function () {
  var button = document.getElementById('blog-load-more');
  if (!button) return;
  var originalText = button.innerText;
  var loadingText = 'Loading...';
  var batchSize = parseInt(button.getAttribute('data-batch-size'), 10) || 12;
  var items = Array.prototype.slice.call(document.querySelectorAll('.blog-article-wrapper [data-article-item]'));
  var hiddenItems = function () {
    return items.filter(function (el) {
      return el.getAttribute('data-article-item') === 'hidden';
    });
  };
  var revealNextBatch = function () {
    button.innerText = loadingText;
    button.disabled = true;
    setTimeout(function () {
      var toReveal = hiddenItems().slice(0, batchSize);
      toReveal.forEach(function (el) {
        el.style.display = '';
        el.setAttribute('data-article-item', 'visible');
      });
      button.innerText = originalText;
      button.disabled = false;

      if (hiddenItems().length === 0) {
        button.style.display = 'none';
      }
    }, 400);
  };
  if (hiddenItems().length === 0) {
    button.style.display = 'none';
  }

  button.addEventListener('click', revealNextBatch);
});


// klaviyo-back-in-stock.js
class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.initBackInStock();

    const klaviyoNotifyButton = this.querySelector("#notify-button");
    const stockForm = this.querySelector(".js-back-in-stock");

    klaviyoNotifyButton?.addEventListener("click", () => {
      stockForm?.classList.remove("klaviyo-hidden");
      klaviyoNotifyButton.classList.add("hidden");
    });
  }

  initBackInStock() {
    const stockForms = this.querySelectorAll(".js-back-in-stock");
    if (!stockForms.length) return;

    stockForms.forEach((formElem) => {
      const emailInput = formElem.querySelector(".klaviyo-email");
      const klaviyoButton = formElem.querySelector(".klaviyo-button.btn");
      const errorElem = formElem.querySelector(".klaviyo-error");

      // Form submit
      formElem.addEventListener("submit", (e) => {
        e.preventDefault();

        const formData = new FormData(formElem);
        const email = formData.get("email");
        const variant_id = formData.get("variant_id");

        if (!this.validateEmail(email)) {
          errorElem?.classList.remove("hidden");
          emailInput.style.borderColor = "#FF3B30";
          return;
        } else {
          errorElem?.classList.add("hidden");
          emailInput.style.borderColor = "";
        }

        this.callKlaviyo(email, variant_id, formElem);
      });

      // Maintain consistent form data
      formElem.addEventListener("formdata", (e) => {
        const formData = e.formData;
        formData.set("email", formData.get("email"));
        formData.set("variant_id", formData.get("variant_id"));
      });
    });
  }

  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.toLowerCase());
  }

  async callKlaviyo(email, variant_id, formElem) {
    if (!email || !variant_id) return;

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2025-01-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${parseInt(variant_id)}`,
              },
            },
          },
        },
      }),
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=KKHsXA",
      options
    )
      .then((response) => response)
      .then((response) => {
        const variant = this.querySelector(
          `[value="${parseInt(variant_id)}"]`
        );
        if (response) {
          if (variant) {
            this.querySelector(".klaviyo-email")?.classList.add("hidden");
            this.querySelector(".klaviyo-button")?.classList.add("hidden");
            this.querySelector(".restock-alert")?.classList.remove("hidden");
          }
        } else {
          console.error("Error: HTTP status", response.status);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

customElements.define("klaviyo-form", KlaviyoForm);

class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.handleResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.mainForm = document.querySelector('.product__info-wrapper .product-form');
    if (!this.mainForm) return;

    this.stickyButton = this.querySelector('.product-form__submit');

    this.observer = new IntersectionObserver(
      ([entry]) => this.onIntersect(entry.isIntersecting),
      { threshold: 0 }
    );

    this.observer.observe(this.mainForm);
    window.addEventListener('resize', this.handleResize);
    this.onResize();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    if (this.observer) this.observer.disconnect();
  }

  onIntersect(isIntersecting) {
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    if (isIntersecting || isDesktop) {
      this.classList.remove('is-sticky');
    } else {
      this.classList.add('is-sticky');
    }
  }

  onResize() {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      this.classList.remove('is-sticky');
    }
  }
}

customElements.define('sticky-atc', StickyAtc);



// In-memory flag — resets on page reload, so the widget reappears after a refresh.
let rebuyClosed = false;

function addRebuyCloseButton() {
  const container = document.querySelector('#rebuy-widget-70635');
  if (!container) return false;

  // Once closed this session, keep it hidden even if the widget re-renders
  if (rebuyClosed) {
    container.style.display = 'none';
    return true;
  }

  // Avoid adding the close button more than once
  if (container.querySelector('.rebuy-custom-close-btn')) return true;

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                          <path d="M6.17616 1.89022C6.31562 1.75075 6.54169 1.75075 6.68116 1.89022C6.82066 2.02969 6.82066 2.25577 6.68116 2.39524L4.79048 4.28559L6.68084 6.17595L6.70559 6.20313C6.81987 6.34341 6.81155 6.55024 6.68084 6.68095C6.55005 6.8117 6.34327 6.81981 6.20302 6.70538L6.1758 6.68095L4.28544 4.79059L2.39581 6.68059C2.25634 6.82009 2.03026 6.82006 1.89079 6.68059C1.75132 6.54113 1.75132 6.31506 1.89079 6.17559L3.78044 4.28559L1.89044 2.39559L1.86602 2.36839C1.7516 2.22812 1.7597 2.02133 1.89044 1.89057C2.02115 1.75986 2.22798 1.75152 2.36825 1.8658L2.39546 1.89057L4.28544 3.78056L6.17616 1.89022Z" fill="#121212"/>
                        </svg>`;
  closeBtn.className = 'rebuy-custom-close-btn';
  closeBtn.setAttribute('aria-label', 'Close');

  closeBtn.addEventListener('click', () => {
    rebuyClosed = true;
    // Lock current height so it can animate down to 0 (collapsing reveals
    // the cart items below with the same timing as the fade).
    container.style.maxHeight = container.scrollHeight + 'px';
    // Force reflow so the browser registers the start value before collapsing.
    void container.offsetHeight;
    container.classList.add('is-hiding');
    // Remove from layout once the collapse finishes
    setTimeout(() => {
      container.style.display = 'none';
    }, 450); // must match the CSS transition duration
  });

  container.appendChild(closeBtn);
  return true;
}

// Try on the rebuy lifecycle event...
document.addEventListener('rebuy.init', addRebuyCloseButton);
document.addEventListener('rebuy.loaded', addRebuyCloseButton);
document.addEventListener('rebuy.change', addRebuyCloseButton);

// ...and watch the DOM, since the widget is re-rendered when the cart goes
// from empty to having items (the old node + close button get replaced).
const rebuyObserver = new MutationObserver(() => addRebuyCloseButton());
rebuyObserver.observe(document.body, { childList: true, subtree: true });

// In case the widget was already present before this script ran
addRebuyCloseButton();